import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ftr_logo from "../assets/new_logo.png";
import dbl_btn from "../assets/btns.png";
import underline from "../assets/underline.png";
import facebook from "../assets/facebeeok.png";
import twitter from "../assets/twitter.png";
import mail from "../assets/mail.png";
import sideline from "../assets/verticalline.png";
import gpay from "../assets/googleplay.png";
import appst from "../assets/appstore.png";
import { Link } from "react-router-dom";

function Footer({ selectedTool, setSelectedTool }) {
  return (
    <div className="ftr" style={{ background: "#B24C76", color: "white" }}>
      <Row className="ftr-r">
        <Col className="col-12 col-md-12 col-sm-12 col-lg-6">
          <div className="logo-cont">
            <Link to="/">
              <img src={ftr_logo} id="logo2" />
            </Link>
            <div>
              <h2 style={{ color: "white" }}>Preggy</h2>
              <hr style={{ width: "25%", backgroundColor: "white" }} />
              <p style={{ color: "white" }}>
                PreggyZone is your go-to guide for every step of your pregnancy
                journey. We provide trusted tips, resources, and support to help
                you feel confident and prepared throughout your entire
                pregnancy.
              </p>
            </div>
          </div>
          <div className="social">
            <h3>Connect With Us</h3>
            <img src={facebook} />
            <img src={twitter} />
            <img src={mail} />
          </div>
        </Col>
        <Col className="col-1 vert">
          <img src={sideline} style={{ height: "300px" }} />
        </Col>
        <Col className="col-12  col-md-12 col-sm-12 col-lg-4 ftr-2 ">
          <h2 style={{ color: "white" }}>Categories</h2>
          <hr style={{ width: "25%", backgroundColor: "white" }} />
          <ul className="ftr-ul ">
            <div>
              <Link
                to="/"
                style={{ textDecoration: "none", color: "white" }}
                onClick={() => setSelectedTool("")}
              >
                {" "}
                <li>Home </li>
              </Link>
              <Link
                to="/aboutus"
                style={{ textDecoration: "none", color: "white" }}
              >
                <li>About Us</li>
              </Link>
            </div>
            <div>
              <Link
                to="/blogs"
                style={{ textDecoration: "none", color: "white" }}
              >
                <li>Blogs</li>
              </Link>
              <Link
                to="/contacts"
                style={{ textDecoration: "none", color: "white" }}
              >
                <li>Contact Us</li>
              </Link>
            </div>
          </ul>
          <div className="app-links">
            <a
              href="https://play.google.com/store/apps/details?id=com.skyraan.preggyzone&pli=1"
              target="_blank"
            >
              <img src={gpay} alt="Googleplay" />
            </a>
            <a
              href="https://apps.apple.com/in/app/pregnancy-tracker-preggy-zone/id6451447686"
              target="_blank"
            >
              <img src={appst} alt="App-Store" />
            </a>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Footer;
